var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1920pt",
    height: "208pt",
    viewBox: "0 0 1920 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,208)",
    d: "M 0 208 L 1920 208 L 1920 -1907 L 0 -1907 Z "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp0)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,208)",
    d: "M 1513.561 155.4966 C 1069.579 296.239 777.7004 -63.16876 278.8768 10.47327 C -219.9469 84.11531 -507.9809 585.8999 -506.3921 676.9219 C -499.8893 1049.468 1747.577 1153.041 1912.661 1177.217 C 2088.908 1203.027 2223.148 650.368 2375.885 647.702 C 2671.686 642.5388 2619.723 1217.174 2614.101 895.1281 C 2608.48 573.0822 2019.514 -4.89098 1513.561 155.4966 Z ",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,208)",
    d: "M 1924.647 208.919 L -.3975892 242.5208 L -4.646848 -.9190413 L 1920.398 -34.52082 Z ",
    fill: "#e2f7ff",
    fillOpacity: 0.9719
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/Oval.9421b584300f5d864d98686e91cbd863.svg";
export { ForwardRef as ReactComponent };